import React, { useCallback, ChangeEventHandler } from 'react';

interface UniversalFilterNumberInputProps {
  value: number;
  autoFocus?: boolean;
  onChange: (value?: number) => void;
}

function UniversalFilterNumberInput({
  value,
  autoFocus,
  onChange
}: UniversalFilterNumberInputProps) {
  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      onChange(parseFloat(event.target.value));
    },
    [onChange]
  );

  return (
    <div className="flex-1">
      <div className="relative">
        <input
          className="basic-input"
          type="number"
          value={value !== undefined && value !== null ? value : ''}
          autoFocus={autoFocus}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default UniversalFilterNumberInput;
